import script from "./score-item-bubble.vue?vue&type=script&lang=ts&setup=true"
export * from "./score-item-bubble.vue?vue&type=script&lang=ts&setup=true"

import "./score-item-bubble.vue?vue&type=style&index=0&id=1a028f78&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a028f78"]])

export default __exports__